import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../axios';

/** GET /v1/settings/company — company business info and branding */
export const useCompanySettings = () => useQuery({
  queryKey: ['settings', 'company'],
  queryFn: () => apiClient.get('/v1/settings/company').then((r) => r.data),
});

/** GET /v1/settings/departments — list all departments */
export const useDepartments = () => useQuery({
  queryKey: ['settings', 'departments'],
  queryFn: () => apiClient.get('/v1/settings/departments').then((r) => r.data),
});

/** GET /v1/settings/designations — list all designations */
export const useDesignations = () => useQuery({
  queryKey: ['settings', 'designations'],
  queryFn: () => apiClient.get('/v1/settings/designations').then((r) => r.data),
});

/** PATCH /v1/settings/company — update company business info */
export const useUpdateCompanySettings = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => apiClient.patch('/v1/settings/company', payload).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['settings', 'company'] }),
  });
};
